import {useApi} from "./useApi";
import {useStoreSelector} from "./redux/useStoreSelector";
import {useCallback} from "react";
import {useFetching} from "./system/useFetching";
import {dispatcher} from "../store";


export function useAssets(isGlobal: boolean = true) {
  const {api, isAuth} = useApi(),
    {withFetching} = useFetching(isGlobal),
    assetClasses = useStoreSelector( s => s.assets.classes),
    assets = useStoreSelector( s => s.assets.list)

  const loadClasses = useCallback(async () => {
    if (isAuth) {
      const res = await withFetching(api.getAssetsClasses({}))
      if (res.status === 200) {
        dispatcher.assets.setClasses(res.body)
      } else {
        //TODO Error handle
      }
    }
  }, [api, isAuth, withFetching])

  const loadAssets = useCallback(async (id: number) => {
    if (isAuth) {
      const res = await withFetching(api.getAssetsClassesByIdAssets({id}))
      if (res.status === 200) {
        dispatcher.assets.setList(res.body)
      } else {
        //TODO Error handle
      }
    }
  }, [api, isAuth, withFetching])


  return {assets, assetClasses, loadAssets, loadClasses}

}
